import * as configPH from '../config/ph/constant';
import * as configID from '../config/id/constant';

const COUNTRY = process.env.REACT_APP_COUNTRY_CODE || 'ph';
const configMap: Record<string, any> = {
  ph: configPH,
  id: configID,
};

const config = configMap[COUNTRY] || configPH;

export const {
  REDIRECT_URL,
  API_URL,
  APIV,
  apikey,
  API_VERSION_V2,
  KEY_ACTIVE_TAB_MAP,
  DESCRIPTION_VALIDATION,
  ROLE_NAME_VALIDATION,
  ROLE_FEATURES,
  DOC_UPLOAD_VALIDATION,
  AGENCY_STATUS,
  STATUS_SUB_STATUS,
  CURRENCY_CODE,
  CURRENCY_SYMBOL,
  APP_TYPE_AGENCY,
  USER_EMAIL_REGEX, 
  USER_NAME_VALIDATION, 
  USERLIST_MOBILE_REGEX, 
  USERLIST_PASSWORD_REGEX,USER_MOBILE_REGEX, 
  USER_PASSWORD_REGEX,
  ALLOW_ALPHABET,
  ALLOW_CHAR_NUM,
  KEY_RECONCILIATION_ACTIVE_TAB_MAP,
  KEY_PAYMENT_ACTIVE_TAB_MAP,
  MANAGER_LEVEL_IDS,
  RAGEX_NUMBER_UPTO_2_DECIMAL_PLACES,
  ROLES,
  PAYMENT_DISSABLE_STATUS,
  ALERT_STATUS,
  AGENT_LEAD_TYPES,
  PAYMENT_TYPE_RADIO,
  ROLE_HIERARCHY,
  LEAD_TYPE_WEB,
  LEAD_TYPE_CRM,
  DATE_RANGES,
  LEAD_STATUS,
  CHEQUE_SLUG,
  REGEX_ONLY_NUMBER,
  RAGEX_NUMBER_UPTO_4_DECIMAL_PLACES,
  REMITTANCE_TYPE,
  LEAD_ASSIGN_TO,
  OPS_ROLE_ID,
  MAKER_ROLE_ID,
  CHECKER_ROLE_ID,
  LEAD_REMITTANCE_STATUS_MARK,
  POST_DATED_CHEQUE_ID,
  LEAD_TYPE_AGENT,
  REMITTANCE_LEVEL_IDS,
  ADMIN_OPS_STATUS,
  ADMIN_MAKER_STATUS,
  ADMIN_CHECKER_STATUS,
  ADMIN_CHECKER_COMPLETE_STATUS,
  COUNTRY_CODE,
  APP_COUNTRY,
  TRENCH_LIST,
  MAX_LEAD_ASSIGN_COUNT,
  ROLE_SLUG_MAP,
  LEAD_LOST_ID,
  LEAD_LOST_SUB_STATUS_ID,
  MOBILE_NO_LENGTH,
  FLAT_DISBURSMENT_FEES,
  INSURER_STATUS,
  STATUS_SUCCESS,
  ONLY_ALPHABET_REGEX,
  PAYSO_QR_PAYMENT_ID,
  PARTNERS_ONLY_FOR_CREDIT_CARD,
  PAYMENT_RECO_STATUS
} = config;